import { msg } from "components/schema/msg";
import { validationPatterns } from "constant/validationPatterns";
import * as Yup from "yup";

export const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email(msg("emailInvalid"))
    .matches(validationPatterns.email, msg("emailFormat"))
    .required(msg("emailRequired")),
});
